import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';

@Pipe({
  name: 'hero-time',
  standalone: true
})
export class HeroTimePipe implements PipeTransform {

  transform(value: number, format : string = 'DD.MM.YYYY HH:mm:ss.SSS'): string {
    if (value === undefined || value === null || isNaN(value)) {
      return 'Invalid date';
    }
    return moment(value).format('DD.MM.YYYY HH:mm:ss.SSS');
  }

}
